import { gql } from '@apollo/client';

// graphql insert site visitor
export const ADD_SITEVISITOR = gql`
  mutation addSitevisitor($sitevisitor: sitevisitor_insert_input!) {
    insert_sitevisitor_one(object: $sitevisitor) {
      id
      visitor_ip
      visited_at
    }
  }
`;

// graphql insert account
export const ADD_ACCOUNT = gql`
  mutation addAccount($account: account_insert_input!) {
    insert_account_one(object: $account) {
      id
      email
      password
      userrole
    }
  }
`;